<template>
  <modal
    :show="show"
    header-classes="justify-content-center center"
    modal-classes="modal-lgest"
    @close="handleClose()"
  >
    <h4 slot="header">
      Vocations
    </h4>

    <collapse
      ref="childCollapseComponent"
    >
      <collapseItem
        title="Add a vocation"
        class="bold-collapse-title"
        :show-caret="false"
        v-loading="isSavingNew"
        element-loading-text="Saving..."
        element-loading-spinner="el-icon-loading"
      >
        <NewForm
          :students="students"
          :select-student="true"
          @close="$emit('close')"
          @saveVocation="handleSaveNewVocation($event)"
          ref="childNewVocationFormComponent"
        />
      </collapseItem>
    </collapse>

    <div
      v-if="vocations"
      v-loading="isSavingInline"
      element-loading-text="Saving..."
      element-loading-spinner="el-icon-loading"
    >
      <div
        v-for="(vocation, index) in vocations"
        :key="vocation.id"
      >
        <div class="container card draggable-card-title" style="padding: 10px;">
          <div class="row">
            <div class="col-md-3">
              {{ vocation.person }}
            </div>
            <div
              :class="{
                'col-md-4': true,
                hide: toBeEditedVocation.id == vocation.id
              }"
            >
              {{ religiousOrSeminary(vocation.vocation) }}
            </div>
            <div
              :class="{
                'col-md-4': true,
                hide: toBeEditedVocation.id !== vocation.id
              }"
            >
              <el-radio v-model="toBeEditedVocation.religiousOrSeminary" label="Religious" />
              <el-radio v-model="toBeEditedVocation.religiousOrSeminary" label="Seminary" />
            </div>
            <div
              :class="{
                'col-md-3': true,
                hide: toBeEditedVocation.id == vocation.id
              }"
            >
              {{ vocation.vocation.diocese_or_order }}
            </div>
            <div
              :class="{
                'col-md-3': true,
                hide: toBeEditedVocation.id !== vocation.id
              }"
            >
              <el-input
                :class="{ hide: toBeEditedVocation.id != vocation.id}"
                class="fit-input"
                type="text"
                placeholder="Order or community"
                v-model="toBeEditedVocation.dioceseOrOrder"
                style="margin:0"
              />
            </div>
            <div class="col-md-2">
              <i
                :class="{ hide: toBeEditedVocation.id !== null }"
                class="el-icon-edit icon-btn"
                @click="handleEdit(index)"
              />
              <i
                :class="{ hide: toBeEditedVocation.id !== vocation.id }"
                class="el-icon-circle-check lrg icon-btn"
                @click="handleSave()"
              />
              <i
                :class="{ hide: toBeEditedVocation.id !== vocation.id }"
                class="el-icon-delete icon-btn float-right"
                @click="handleDelete()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from '../UIComponents/Modal';
import NewForm from './VocationsForm.vue';
import collapse from '../UIComponents/Collapse/Collapse';
import collapseItem from '../UIComponents/Collapse/CollapseItem';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const GraduationRecordsRepository = RepositoryFactory.get('graduationRecords');

export default {
    name: 'VocationsModal',
    components: {
        modal,
        NewForm,
        collapse,
        collapseItem
    },
    data() {
        return {
            namespace: 'Vocations',
            toBeEditedVocation: {
                id: null,
                graduationStatus: null,
                religiousOrSeminary: null,
                dioceseOrOrder: null
            },
            isSavingNew: false,
            isSavingInline: false,
        };
    },
    props: {
        vocations: {
            type: Array,
            default: null
        },
        students: {
            type: Array,
            default() { return []; }
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getVocationFromIndex(index) {
            return this.vocations[index];
        },
        handleEdit(index) {
            const editThis = this.getVocationFromIndex(index);
            this.toBeEditedVocation.id = editThis.id;
            if (editThis.vocation.is_entering_religious === true) {
                this.toBeEditedVocation.religiousOrSeminary = 'Religious';
            } else if (editThis.vocation.is_entering_seminary === true) {
                this.toBeEditedVocation.religiousOrSeminary = 'Seminary';
            } else {
                this.toBeEditedVocation.religiousOrSeminary = null;
            }
            this.toBeEditedVocation.dioceseOrOrder = editThis.vocation.diocese_or_order;
            this.toBeEditedVocation.graduationStatus = editThis.graduation_status;
        },
        handleSave() {
            this.isSavingInline = true;
            let seminary = false;
            let religious = false;
            if (this.toBeEditedVocation.religiousOrSeminary === 'Religious') {
                religious = true;
            } else if (this.toBeEditedVocation.religiousOrSeminary === 'Seminary') {
                seminary = true;
            }
            GraduationRecordsRepository.updateGraduationRecords(
                [
                    {
                        id: this.toBeEditedVocation.id,
                        vocation: {
                            is_entering_religious: religious,
                            is_entering_seminary: seminary,
                            diocese_or_order: this.toBeEditedVocation.dioceseOrOrder,
                        }
                    }
                ]
            )
                .then((response) => {
                    this.$emit('newVocationSaved', response.data);
                    this.toBeEditedVocation.id = null;
                    this.toBeEditedVocation.graduationStatus = null;
                    this.toBeEditedVocation.religiousOrSeminary = null;
                    this.toBeEditedVocation.dioceseOrOrder = null;
                    this.isSavingInline = false;
                })
                .catch((error) => {
                    this.$message(error.response.data.message);
                    this.isSavingInline = false;
                });
        },
        handleDelete() {
            this.isSavingInline = true;
            GraduationRecordsRepository.updateGraduationRecords(
                [
                    {
                        id: this.toBeEditedVocation.id,
                        vocation: {
                            is_entering_religious: false,
                            is_entering_seminary: false,
                            diocese_or_order: null,
                        }
                    }
                ]
            )
                .then((response) => {
                    this.$emit('newVocationSaved', response.data);
                    if (this.toBeEditedVocation.graduationStatus === 'Vocation only') {
                        this.$alert('Successfully deleted. Since this person is not a senior, you will not find their graduation form outside of the vocations popup unless you manually add them underneath the progress bar or re-add them as a vocation here.');
                    } else {
                        this.$alert('Successfully deleted. Since this person is a senior, you can still find their graduation form outside of the vocations popup.');
                    }
                    this.toBeEditedVocation.id = null;
                    this.toBeEditedVocation.graduationStatus = null;
                    this.toBeEditedVocation.religiousOrSeminary = null;
                    this.toBeEditedVocation.dioceseOrOrder = null;
                    this.isSavingInline = false;
                })
                .catch((error) => {
                    this.$message(error.response.data.message);
                    this.isSavingInline = false;
                });
        },
        handleSaveNewVocation(event) {
            this.isSavingNew = true;
            GraduationRecordsRepository.createNewVocation(event.student.id, event)
                .then((response) => {
                    this.$message('Successfully saved vocation!');
                    this.$emit('newVocationSaved', response.data);
                    this.toBeEditedVocation.id = null;
                    this.toBeEditedVocation.graduationStatus = null;
                    this.toBeEditedVocation.religiousOrSeminary = true;
                    this.toBeEditedVocation.dioceseOrOrder = null;
                    this.$refs.childNewVocationFormComponent.clearInputs();
                    this.isSavingNew = false;
                })
                .catch((error) => {
                    this.$message(error.response.data.message);
                    this.isSavingNew = false;
                });
        },
        handleClose() {
            this.toBeEditedVocation.id = null;
            this.toBeEditedVocation.graduationStatus = null;
            this.toBeEditedVocation.religiousOrSeminary = true;
            this.toBeEditedVocation.dioceseOrOrder = null;
            this.$emit('close');
        },
        religiousOrSeminary(vocation) {
            if (vocation.is_entering_religious) {
                return 'Religious';
            }
            if (vocation.is_entering_seminary) {
                return 'Seminary';
            }
            return null;
        }
    },
};
</script>
<style>
</style>
<style scoped>
.modal {
  overflow: scroll;
}
.hide {
  display: none;
}
</style>
